import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Typography,
  Button,
  Box,
  Popover,
  PopoverOrigin,
  DialogActions,
} from '@mui/material'

import { PopoverConfirmType } from '@/state/ui/global/models'

interface Props extends PopoverConfirmType {
  handleClosePopoverConfirm: () => void
}

export const PopoverConfirmComponent = (props: Props) => {
  const { t } = useTranslation()

  const {
    anchorPosition,
    action,
    type,
    handler,
    optional,
    open,
    handleClosePopoverConfirm,
  } = props

  const { message, btnText, cancelBtnText, caption, color } = optional || {}

  const dialogMessage =
    message ||
    t('messages.confirmAction', {
      action,
      item: type,
    })

  const popoverAnchorOrigin: PopoverOrigin = {
    vertical: 'bottom',
    horizontal: 'center',
  }

  const popoverTransformOrigin: PopoverOrigin = {
    vertical: 'top',
    horizontal: 'left',
  }

  useEffect(() => {
    return () => {
      handleClosePopoverConfirm()
    }
  }, []) // eslint-disable-line

  return (
    <Popover
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      open={open}
      onClose={handleClosePopoverConfirm}
      anchorOrigin={popoverAnchorOrigin}
      transformOrigin={popoverTransformOrigin}
      sx={{ zIndex: 1301 }}
    >
      <Box maxWidth={350} p={1}>
        <Box p={1}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {dialogMessage.charAt(0).toUpperCase() + dialogMessage.slice(1)}
          </Typography>
          {caption && (
            <Box mt={1}>
              <Typography variant="caption">{caption}</Typography>
            </Box>
          )}
        </Box>
        <DialogActions sx={{ p: 1 }}>
          <Button className="red" onClick={handleClosePopoverConfirm}>
            {cancelBtnText || t('labels.cancel')}
          </Button>
          <Button
            onClick={(
              event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
            ) => {
              handleClosePopoverConfirm()
              handler(event)
            }}
            variant="contained"
            className={color || 'red'}
            autoFocus
          >
            {btnText || `${t('yes')}, ${action}`}
          </Button>
        </DialogActions>
      </Box>
    </Popover>
  )
}
